import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { domain } from 'process';
//import { AccountFeature, BillingAccountInformation } from 'src/app/models/billing/BillingAccountInfo';
import { environment } from 'src/environments/environment';
import { UtilService } from '../util.service';
import { AccountPlanConfig } from 'src/app/models/school/schooladminitem.model';

@Injectable({
  providedIn: 'root'
})
export class BillingAccountService {

  readonly rootURL = environment.ImpataAppAPIRoot;

  constructor( private http:HttpClient) { }

  // getUserBillingAccounts(){
  //   return this.http.get( this.rootURL + "BillingAccount/getbillingaccounts");
  // }

  // saveBillingAccount( accountinfo:BillingAccountInformation){
  //   return this.http.post( this.rootURL + "BillingAccount/updatebillingaccount", accountinfo);
  // }

  getAllMonthlyBills(){
    
    return this.http.get( this.rootURL + `BillingAccount/getAccountMonthlyBills`);
  }

  getAllMonthlyBillDetail(billID:number){
    return this.http.get( this.rootURL + `BillingAccount/getAccountMonthlyBillDetails?bid=${billID}`);
  }

  getAvailableSchoolPlans(){
    return this.http.get<AccountPlanConfig[]>(this.rootURL + `BillingAccount/getPlans`);
  }
  
  getCurrentSchoolPlan(){
    return this.http.get(this.rootURL + `BillingAccount/getCurrentPlan`);
  }

  getVCirclePlans(){
    return this.http.get(this.rootURL + `BillingAccount/getVCirclePlans`);
  }
  // getCurrentVCirclePlan(){
  //   return this.http.get(this.rootURL + `BillingAccount/getCurrentVCirclePlan`);
  // }
  
}
